import Vue from "vue";
import Component from "vue-class-component";
import * as LoadingGif from "@/assets/gifs/loading.gif";

@Component({
  name: "LoadingSideModal",
})
export default class LoadingSideModal extends Vue {
  cx_loading_gif = LoadingGif;
  /**
   * -----------------------------------------
   * EVENTS
   * -----------------------------------------
   */
}
